import { validators } from "./validators.js";
export const ENV_DEFINITIONS = {
    // Core Supabase configuration (required for all operations)
    SUPABASE_URL: {
        validator: validators.supabaseUrl,
        error: "Must be a valid Supabase URL",
        required: true,
        description: "Supabase project URL - required for database access",
    },
    SUPABASE_SERVICE_KEY: {
        validator: validators.jwt,
        error: "Must be a valid JWT token",
        required: true,
        description: "Supabase service role key - required for admin database operations",
    },
    SUPABASE_ANON_KEY: {
        validator: validators.jwt,
        error: "Must be a valid JWT token",
        description: "Supabase anonymous key - optional, used for client-side operations",
    },
    // Encryption (required for storing OAuth tokens securely)
    // NOTE: Uses base64 format for compatibility with crypto.ts encrypt/decrypt functions
    ENCRYPTION_KEY: {
        validator: validators.base64,
        error: "Must be a valid base64-encoded 256-bit key (at least 32 characters)",
        required: true,
        description: "Encryption key for securing OAuth tokens and sensitive data",
    },
    // OAuth test account management
    CHECKOUT_DURATION_MINUTES: {
        validator: validators.range(1, 1440), // 1 minute to 24 hours
        error: "Must be between 1 and 1440 minutes",
        description: "Test account checkout duration (agent-tester feature)",
        transform: (v) => parseInt(v),
    },
    MAX_CHECKOUTS_PER_IP: {
        validator: validators.range(1, 100),
        error: "Must be between 1 and 100",
        description: "Maximum test account checkouts per IP address (agent-tester feature)",
        transform: (v) => parseInt(v),
    },
    // OAuth providers (optional - only needed for task provider integrations)
    MICROSOFT_TODO_CLIENT_ID: {
        validator: validators.minLength(10),
        error: "Must be at least 10 characters",
        description: "Microsoft OAuth client ID - required for Microsoft Todo provider",
    },
    MICROSOFT_TODO_CLIENT_SECRET: {
        validator: validators.minLength(10),
        error: "Must be at least 10 characters",
        description: "Microsoft OAuth client secret - required for Microsoft Todo provider",
    },
    MICROSOFT_TODO_TENANT: {
        validator: validators.minLength(1),
        error: "Must be specified",
        description: "Microsoft OAuth tenant - defaults to 'common' if not specified (supports personal & organizational accounts)",
    },
    // Google Tasks (placeholder for future implementation)
    GOOGLE_TASKS_CLIENT_ID: {
        validator: validators.minLength(10),
        error: "Must be at least 10 characters",
        description: "Google OAuth client ID - required for Google Tasks provider",
    },
    GOOGLE_TASKS_CLIENT_SECRET: {
        validator: validators.minLength(10),
        error: "Must be at least 10 characters",
        description: "Google OAuth client secret - required for Google Tasks provider",
    },
    // Todoist
    TODOIST_CLIENT_ID: {
        validator: validators.minLength(10),
        error: "Must be at least 10 characters",
        description: "Todoist OAuth client ID - required for Todoist provider",
    },
    TODOIST_CLIENT_SECRET: {
        validator: validators.minLength(10),
        error: "Must be at least 10 characters",
        description: "Todoist OAuth client secret - required for Todoist provider",
    },
    // Stripe (optional - only needed for billing/subscriptions)
    STRIPE_SECRET_KEY: {
        validator: validators.stripeKey,
        error: "Must be a valid Stripe secret key",
        description: "Stripe API key - required for subscription billing",
    },
    STRIPE_WEBHOOK_SECRET: {
        validator: validators.minLength(20),
        error: "Must be at least 20 characters",
        description: "Stripe webhook secret - required for handling subscription events",
    },
    // Monitoring and observability (optional)
    BETTER_STACK_SOURCE_TOKEN: {
        validator: validators.minLength(20),
        error: "Must be at least 20 characters",
        description: "Better Stack logging token - optional for production logging",
    },
    BETTER_STACK_INGEST_URL: {
        validator: validators.url,
        error: "Must be a valid URL",
        description: "Better Stack ingesting host for the source token - optional, defaults to the Logtail endpoint",
    },
    SENTRY_DSN: {
        validator: validators.url,
        error: "Must be a valid URL",
        description: "Sentry DSN - optional for error tracking",
    },
    // Environment specification (optional)
    ENVIRONMENT: {
        validator: validators.enum(["development", "production", "test"]),
        error: "Must be development, production, or test",
        description: "Deployment environment - defaults to 'development' if not specified",
    },
    // Email service configuration (optional - only needed for email-to-task features)
    GATEWAY_URL: {
        validator: validators.url,
        error: "Must be a valid URL",
        description: "API gateway URL - required for email worker to communicate with API",
    },
    EMAIL_SERVICE: {
        validator: validators.enum(["plunk", "ses", "cloudflare"]),
        error: "Must be plunk, ses, or cloudflare",
        description: "Email service provider - required for sending email notifications",
    },
    EMAIL_FROM: {
        validator: validators.email,
        error: "Must be a valid email address",
        description: "From address for outgoing emails - required for email notifications",
    },
    PLUNK_API_KEY: {
        validator: validators.minLength(20),
        error: "Must be at least 20 characters",
        description: "Plunk API key - required if using Plunk as email service",
    },
    SYSTEM_TOKEN: {
        validator: validators.hex(32),
        error: "Must be at least 32 hex characters",
        description: "System authentication token - required for email worker to authenticate with API",
    },
    // Cloudflare (optional - only needed for deployment automation)
    CLOUDFLARE_API_TOKEN: {
        validator: validators.minLength(20),
        error: "Must be at least 20 characters",
        description: "Cloudflare API token - optional, used for deployment automation",
    },
    CLOUDFLARE_ACCOUNT_ID: {
        validator: validators.minLength(20),
        error: "Must be at least 20 characters",
        description: "Cloudflare account ID - optional, used for deployment automation",
    },
};
//# sourceMappingURL=env-definitions.js.map